import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  private isAuthenticated: BehaviorSubject<boolean>;
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this.isAuthenticated) {
      this.isAuthenticated = new BehaviorSubject<boolean>(false);
      this.authService.isAuthenticatedStream.subscribe(isAuth => {
        if (isAuth) {
          this.isAuthenticated.next(true);
        } else {
          //this.router.navigate(['login']);
          this.isAuthenticated.next(false);
        }
      });
    }

    return this.isAuthenticated.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/guard/auth-guard.ts